import JsonMapper from "./JsonMapper";
export default class JsonMappedModel extends JsonMapper {
  constructor(data) {
    super(data);
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  getId() {
    return this.getAttribute(this.constructor.getIdAttributeName());
  }
}